var x = {"GOOGLE_ANALYTICS_KEY":"G-K9SV5YKZHZ"};module.exports = x ;